// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2x81N","title":"BackImages_title__Ng_-s","images":"BackImages_images__2DZxE"};